module.exports = __webpack_public_path__ + "img/shezhi.76cd7c9b.png";